import { LocationDataRow } from '@warebee/shared/dataset-queries';
import {
  HeatmapMetricDescriptor,
  HeatmapMetricDescriptorBase,
} from '../../common/heatmap.types';

export const locationMetrics = [
  'locationOrder',
  'locationStatus',
  'locationLevel',
  'locationLength',
  'locationWidth',
  'locationHeight',
  'locationWeight',
  'locationBayTitle',
  'locationBayPosition',
  'locationDepthPosition',
  'locationUsageType',
  'locmhtype',
  'locationRackingType',
  'warehouseArea',
  'locationSide',
  'congestionZone',
  'locationHeightFromFloor',
  'locationDepthFromFront',
  'locationIndexFromFront',
  'bayType',
  'aisleTitle',
  'planeTitle',
] as const;

export type LocationMetric = (typeof locationMetrics)[number];

export type LocationMetricDescriptorBase = HeatmapMetricDescriptorBase<
  LocationMetric,
  LocationMetricDataRow
>;

export type LocationMetricDescriptor = HeatmapMetricDescriptor<
  LocationMetric,
  LocationMetricDataRow
>;

export type LocationMetricDataRow = LocationDataRow;
